import type { Product } from '../pages/ProductMatrixNew';

// Custom sort order for product modules (software products)
export const sortProductModules = (products: Product[]) => {
  const moduleOrder = [
    'POS Terminal',
    'Customer Facing Display',
    'Glass Tablet POS',
    'Air Mobile POS',
    'Kiosk',
    'Kitchen Display System',
    'Online Ordering',
    'QR Pay',
    'Gift Cards',
    'Loyalty',
    'Multi-Location Management',
    'Website Builder',
    'Workforce',
    'Capital',
    'Business Intelligence',
    'Launch Control',
    'Grow My Business',
    'Supply Ordering',
    'Hardware Ordering'
  ];

  return [...products].sort((a, b) => {
    const indexA = moduleOrder.findIndex(pm => a.solution.toLowerCase().includes(pm.toLowerCase()));
    const indexB = moduleOrder.findIndex(pm => b.solution.toLowerCase().includes(pm.toLowerCase()));

    // If both are in the priority list, sort by priority order
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    // If only A is in the list, it comes first
    if (indexA !== -1) return -1;

    // If only B is in the list, it comes first
    if (indexB !== -1) return 1;

    // If neither is in the list, sort alphabetically
    return a.solution.localeCompare(b.solution);
  });
};
